import React from 'react';
import { useHistory } from 'react-router-dom';

import './styles.css';
import Header from '../Includes/Header';
import Footer from '../Includes/Footer';
import TituloPagina from '../Includes/Titulos';
import api from '../../services/api';

export default function CancelPlan(){
    const history = useHistory();
    const BASE_URL = 'https://agrobrazilapp.com/';
    const USER_EMAIL = sessionStorage.getItem('email');
    const USER_TOKEN = sessionStorage.getItem('token');

 function handleCancelPlan(){
    var axios = require('axios');
    var FormData = require('form-data');
    var data = new FormData();
    data.append('USER_TOKEN', USER_TOKEN);
    data.append('USER_EMAIL', USER_EMAIL);
    var config = {
      method: 'post',
      url: `${BASE_URL}/v4/users/me/cancel_subscription`,
      headers: { 
        'USER_EMAIL': USER_EMAIL, 
        'USER_TOKEN': USER_TOKEN,
      },
     
    };
    
    axios(config)
    .then(function (response) {
      console.log(JSON.stringify(response.data));
      sessionStorage.setItem('plan',response.data);
    })
    .catch(function (error) {
      console.log(error);
    });
    
 }

    return(
        <>
      <div class="address-container">
            <Header />

          <TituloPagina titulo="Cancelamento Plano" />
            
                    <div onLoad={handleCancelPlan} class="body-address">
                   
                    </div>
           

            <Footer />
            </div>
        </>
    );
}
